import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import theme from "styles/theme";
import { DATATEST } from "constants/integration";

interface IProps {
    limit: number;
    current: number;
    error?: string | null;
}

export const StringLengthCounter: React.FC<IProps> = ({ limit = 0, current = 0, error }) => {
    const classes = useStyles();
    return (
        <span className={classes.container}>
            <span className={classes.error} data-test={DATATEST.CUSTOMIZATIONS.TEXT_ATTRIBUTE_ERROR}>
                {error}
            </span>
            <span
                className={classes.charCounter}
                data-test={DATATEST.CUSTOMIZATIONS.LENGTH_COUNTER}
            >{`${current}/${limit}`}</span>
        </span>
    );
};

const useStyles = makeStyles({
    charCounter: {
        fontSize: "14px",
    },
    error: {
        color: theme.palette.error,
    },
    container: {
        display: "flex",
        justifyContent: "space-between",
    },
});
